import styles from "./ScheduleSelect.module.css";

export const ScheduleSelect = ({
  title,
  value,
  onChange,
  children,
  classNames,
}) => {
  return (
    <div className={classNames}>
      <h2>{title}</h2>
      <div className={styles.scheduleSwither__input}>
        <select
          className={styles.scheduleSwither}
          value={value}
          onChange={onChange}
        >
          {children}
        </select>
      </div>
    </div>
  );
};
